import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from '../locales/es.json';
import en from '../locales/en.json';
import pt from '../locales/pt.json';
import fr from '../locales/fr.json';
import it from '../locales/it.json';
import zh from '../locales/zh.json';
import ko from '../locales/ko.json';
import ja from '../locales/ja.json';
import ar from '../locales/ar.json';
import de from '../locales/de.json';
import ru from '../locales/ru.json';
import tr from '../locales/tr.json';
import nl from '../locales/nl.json';
import hi from '../locales/hi.json';
import pl from '../locales/pl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
      fr: { translation: fr },
      it: { translation: it },
      zh: { translation: zh },
      ko: { translation: ko },
      ja: { translation: ja },
      ar: { translation: ar },
      de: { translation: de },
      ru: { translation: ru },
      tr: { translation: tr },
      nl: { translation: nl },
      hi: { translation: hi },
      pl: { translation: pl }
    },
    supportedLngs: ['es', 'en', 'pt', 'fr', 'it', 'zh', 'ko', 'ja', 'ar', 'de', 'ru', 'tr', 'nl', 'hi', 'pl'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'enigma_language',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => lng.split('-')[0]
    }
  });

export default i18n;
